<div>
    <ng-container *ngTemplateOutlet="mode === 'formula' ? formulaSetup : variableSetup"></ng-container>
</div>


<ng-template #formulaSetup>
    <ng-container *ngTemplateOutlet="dividerSetup; context: createTemplateContext('Variables')"></ng-container>
    <div *ngIf="!variables.length" class="p-d-flex p-flex-column p-ai-center p-jc-center">
        <label>
            No variables defined
        </label>
        <button pButton
                label="Add variable"
                [icon]="Icons.PLUS"
                class="p-button-text p-button-success"
                (click)="mode = 'variable'">
        </button>
    </div>

    <div *ngIf="variables.length" class="p-grid p-nogutter">
        <div *ngFor="let variable of variables" class="p-mb-3 p-col-12 p-grid p-nogutter p-jc-between">
            <div class="p-mr-3 p-col-5 p-d-flex p-ai-center">
                <label [for]="keyedId(variable.reference)">{{variable.name}} = {{getReferenceLabelForVariable(variable)}}</label>
            </div>
            <div class="p-col">
                <div class="p-inputgroup">
                    <input pInputText
                           [id]="keyedId(variable.reference)"
                           placeholder="Test value"
                           (input)="execute()"
                           [(ngModel)]="testValues[variable.reference]">
                    <span class="p-inputgroup-addon">
                        <p-checkbox
                                [binary]="true"
                                [(ngModel)]="variable.optional"
                                label="Optional"></p-checkbox>
                    </span>
                    <button pButton
                            class="p-button-danger"
                            icon="pi pi-trash"
                            (click)="removeVariable(variable)"></button>
                </div>
            </div>
        </div>
        <div class="p-col p-text-right p-mt-3">
            <button pButton
                    label="Add variable"
                    [icon]="Icons.PLUS"
                    class="p-button-success p-button-text p-p-0"
                    (click)="mode = 'variable'"></button>
        </div>
    </div>
	
	<div *ngIf="canUseDecimalPlaces()" class="mb-2">
		<ng-container *ngTemplateOutlet="dividerSetup; context: createTemplateContext('Format')"></ng-container>
		<div class="flex items-center gap-x-1">
			<div class="w-4/12">
				<label [for]="keyedId('decimalPlaces')">Round to decimal places</label>
			</div>
			<div class="w-8/12">
				<p-inputNumber (onInput)="execute()"
				               (onBlur)="execute()"
				               [(ngModel)]="decimalPlaces"
				               [format]="false"
				               [inputId]="keyedId('decimalPlaces')"
				               [maxFractionDigits]="0"
				               [max]="15"
				               [min]="0"
				               [showButtons]="true"
				               class="w-full"
				               placeholder="Decimal places"
				               styleClass="w-full">
				</p-inputNumber>
			</div>
		</div>
	</div>

	<ng-container *ngTemplateOutlet="dividerSetup; context: createTemplateContext('Output')"></ng-container>
	
	<div class="flex flex-col mb-2">
		<div class="p-inputgroup">
			<div class="p-float-label">
				<input id="formula-editor-result-{{key}}"
				       pInputText
				       disabled
				       class="w-100 ng-dirty"
				       [ngClass]="{'ng-invalid': testResultError}"
				       [(ngModel)]="testResult">
				<label for="formula-editor-result-{{key}}">Result</label>
			</div>
			<button pButton
			        label="Execute"
			        [icon]="Icons.PLAY"
			        [disabled]="!formula.length"
			        (click)="execute(true)"></button>
		</div>
		<small *ngIf="testResultError as errorText" class="p-error">
			{{ errorText }}
		</small>
	</div>

    <ng-container *ngTemplateOutlet="dividerSetup; context: createTemplateContext('Formula')"></ng-container>

    <textarea pInputTextarea [(ngModel)]="formula"
              style="width: 100%; height: 200px; font-family: 'monospace';"
              (input)="execute()"
              [autoResize]="true"
              placeholder="Calculation formula"></textarea>

</ng-template>

<ng-template #variableSetup>
    <div lb-events (onInit)="newVariableNode = undefined">
        <button pButton
                label="Back"
                [icon]="Icons.ARROW_LEFT"
                class="p-button-secondary"
                (click)="mode = 'formula'"></button>
    </div>
    <ng-container *ngTemplateOutlet="dividerSetup; context: createTemplateContext('Add Variable')"></ng-container>

    <div class="p-grid p-flex-column">
        <div class="p-col">
            <p-treeSelect (onNodeSelect)="variableNameFormControl.reset('')"
                          [(ngModel)]="newVariableNode"
                          [filter]="true"
                          [options]="availableVariableReferences"
                          appendTo="body"
                          containerStyleClass="w-100"
                          panelStyleClass="formula-editor-variable-tree"
                          placeholder="Variable target"></p-treeSelect>
        </div>


        <div *ngIf="newVariableSegment" class="p-col p-d-flex p-flex-column">
            <div class="p-inputgroup">
                <input pInputText placeholder="Variable name" [formControl]="variableNameFormControl">
                <button pButton
                        label="Add"
                        icon="pi pi-plus"
                        style="align-self: end"
                        (click)="addVariable() && (mode = 'formula')"></button>
            </div>
            <small *ngIf="getControlErrorText(variableNameFormControl) as errorText" class="p-error">{{errorText | titlecase}}</small>
        </div>
    </div>
</ng-template>

<ng-template #dividerSetup let-title>
  <ng-container *ngIf="title; else empty">
    <div class="divider-container">
      <div>
        <p-divider></p-divider>
      </div>
      <div>
        <label class="p-0">{{title}}</label>
      </div>
      <div>
        <p-divider></p-divider>
      </div>
    </div>
  </ng-container>
  <ng-template #empty>
    <p-divider></p-divider>
  </ng-template>
</ng-template>